
import { defineComponent, useStore, ref } from '@nuxtjs/composition-api'
import CookieConsentBanner from '~/components/cookieConsent/cookieConsent.vue'
import Navigation from '~/components/navigation/Navigation.vue'
import Promotion from '~/components/promotion/Promotion.vue'
import { CookieConsent } from '~/assets/ts/CookieConsent'

export default defineComponent({
  components: { CookieConsentBanner, Navigation, Promotion },
  setup() {
    const mobileNavi = ref(false)

    if (process.client) {
      const acredoCookieConsent = new CookieConsent(
        process.env.NUXT_ENV_DEFAULT_CODE || ('de' as string), true
      )

      if (document.cookie.includes('debugTracking=yes')) {
        console.debug(
          'Cookie consent areMarketingCookiesAllow:',
          acredoCookieConsent.areMarketingCookiesAllow(),
        )
        console.debug(
          'Cookie consent showConsentDialog:',
          acredoCookieConsent.showConsentDialog()
        )
      }
    }

    const setMobileNavi = (value: boolean) => {
      mobileNavi.value = value
    }

    return { mobileNavi, setMobileNavi }
  },
})
